// Утилитная функция для получения фильтров из sessionStorage
export const getFiltersFromSessionStorage = () => {
  const savedFilters = sessionStorage.getItem('accountsFilter')
  if (savedFilters) {
    const filters = JSON.parse(savedFilters)
    if (filters.clientId) {
      const apiFilters: any = { client: Number(filters.clientId) }
      if (filters.startDate)
        apiFilters.date_from = new Date(filters.startDate)
          .toISOString()
          .split('T')[0]
      if (filters.endDate)
        apiFilters.date_to = new Date(filters.endDate)
          .toISOString()
          .split('T')[0]
      if (filters.countryId) apiFilters.country = filters.countryId
      if (filters.statusId !== undefined && filters.statusId !== '') {
        apiFilters.paid = filters.statusId
      }
      return apiFilters
    }
  }
  return undefined
}
